import moment from "moment";
import React from "react";
import { IBasicFilter } from "../../../../utils/common-type";
import { getCurrentTimeZone, pageSizeList } from "../../../../utils/helper";

export interface IBulletin {
  title: string;
  content: string; // TODO check schema
  startTime: string;
  endTime: string;
  createTime: string;
}

export interface IBulletinForm {
  title: string;
  content: string; // TODO check schema
  startTime: moment.Moment;
  endTime: moment.Moment;
}

export interface IFilter extends IBasicFilter {
  time: moment.Moment[];
  zone: string;
  title: string;
}

export interface ISearchProps {
  filter: IFilter;
  setFilter: React.Dispatch<React.SetStateAction<IFilter>>;
  downloadData: IBulletin[];
}

export interface IFormProps {
  tempData: IBulletinForm;
  dialogType: string | null;
  setDialogType: React.Dispatch<React.SetStateAction<string | null>>;
  onCreate: (payload: IBulletinForm) => void;
  onEdit: (payload: IBulletinForm) => void;
}

export const sortableColumns = ["title", "startTime", "endTime", "createTime"];

export const formInitialValues: IBulletinForm = {
  title: "",
  content: "",
  startTime: moment(),
  endTime: moment(),
};

export const defaultFilter: () => IFilter = () => ({
  time: [moment().startOf("days"), moment().endOf("days")],
  pages: 0,
  pageSize: Number(localStorage.getItem("pageSize")) || pageSizeList[0],
  order: undefined,
  orderBy: undefined,
  zone: getCurrentTimeZone(),
  title: "",
});
